import { allPermissions } from '../general/utils/authHelper';
import Permission from '../shared/constants/Permission';
import { surveyContextLoader } from './loaders';

const SatisfactionPage = () => import('./views/SatisfactionPage.vue');

export default [
  {
    path: '/customer-satisfaction',
    name: 'customer-satisfaction',
    component: SatisfactionPage,
    meta: {
      title: 'survey.pageTitle',
      hasAccess: allPermissions(Permission.CAN_SEE_CSS_TASKS),
      logicalModule: 'customer-satisfaction',
    },
    props: {
      context: surveyContextLoader,
    },
  },
];
